import { useEffect, useState } from "react";
import { apiClient } from "@/lib/api/client";

export function AdminInfoPage() {
  const [apiCommitSha, setApiCommitSha] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const webCommitSha = import.meta.env.VITE_COMMIT_SHA ?? "unknown";

  useEffect(() => {
    async function fetchInfo() {
      const { data, error } = await apiClient.GET("/api/admin/info");
      if (error) {
        setError("Impossible de récupérer les informations de l'API.");
        setLoading(false);
        return;
      }
      setApiCommitSha(data.data.commitSha);
      setLoading(false);
    }
    fetchInfo();
  }, []);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="mb-6 text-2xl font-semibold text-zinc-900 dark:text-zinc-100">
        Informations de déploiement v2
      </h1>
      <div className="overflow-hidden rounded-lg border border-zinc-200 dark:border-zinc-800">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-zinc-200 bg-zinc-50 dark:border-zinc-800 dark:bg-zinc-900">
              <th className="px-4 py-3 text-left font-medium text-zinc-500 dark:text-zinc-400">
                Service
              </th>
              <th className="px-4 py-3 text-left font-medium text-zinc-500 dark:text-zinc-400">
                Commit
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-200 bg-white dark:divide-zinc-800 dark:bg-zinc-950">
            <tr>
              <td className="px-4 py-3 font-medium text-zinc-900 dark:text-zinc-100">
                Web
              </td>
              <td className="px-4 py-3 font-mono text-zinc-600 dark:text-zinc-400">
                {webCommitSha}
              </td>
            </tr>
            <tr>
              <td className="px-4 py-3 font-medium text-zinc-900 dark:text-zinc-100">
                API
              </td>
              <td className="px-4 py-3 font-mono text-zinc-600 dark:text-zinc-400">
                {loading && "Chargement…"}
                {error && <span className="text-red-500">{error}</span>}
                {!loading && !error && apiCommitSha}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export type AdminInfoPageProps = Record<string, never>;
